<p-panel>
  <app-reactive-form-builder 
    (formChanges)="formChanges($event[0], $event[1])" 
    (goBack)="goBack()"
    [form]="form.formFields" 
    [serverUrl]="form.env.auxServerUrl"
    [dropdownLoadTrigger]="dropdownLoadTrigger" 
    [dropdownsFinalized]="dropdownsFinalized"
    [id]="(getModel().id)?.toString() ?? ''"
    [request]="this.getType() === 1 ? this.tareasApi.fertirrigacion.PUT : this.tareasApi.fertirrigacion.POST"
    [getRequest]="this.tareasApi.fertirrigacion.GET">
  </app-reactive-form-builder>
</p-panel>